import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import * as actions from './actions'
import suggestion from './modules/suggestion'
import topics from './modules/topics'
import user from './modules/user'
import signup from './modules/signup'
import folders from './modules/folders'
import accounts from './modules/accounts'
import notes from "./modules/notes"
import teamMembers from "./modules/team-members"
import viewOptions from "./modules/viewOptions"
import preferences from "./modules/user-preferences";
import collections from "./modules/collections";
import filters from "./modules/filters";
import age from "./modules/filter-fields/age.js";
import cancelTokens from "./modules/cancel-token";
import publishers from "./modules/publishers";
import filterViews from "./modules/filter-views";
import suggestionSettings from "./modules/suggestion-settings";
import contentTemplates from "./modules/contentTemplates";
import galleries from "./modules/galleries";
import generalState from "./modules/general-state";
import suggestionManagement from "./modules/suggestion-management";
import appVersion from './modules/version';
import thirdPartyApis from "./modules/third-party-apis"
import config from './modules/config'
import sniply from './modules/integrations/sniply'
import postText from './modules/post-text'
import classifiers from "@/store/modules/content-policies"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';
const testing = process.env.NODE_ENV === 'testing';

const modules = {
    cancelTokens,
    suggestion,
    topics,
    user,
    signup,
    folders,
    accounts,
    notes,
    teamMembers,
    viewOptions,
    preferences,
    collections,
    suggestionManagement,
    appVersion,
    config,
    galleries,
    thirdPartyApis,
    generalState,
    filters,
    age,
    filterViews,
    publishers,
    suggestionSettings,
    contentTemplates,
    sniply,
    postText,
    classifiers,
};

const initialState = (modules) => {
    Object.keys(modules).reduce((state, module) => ({
        ...state,
        [module]: modules[module]
    }), {})
};

const mutations = {
    USER_DID_LOG_OUT(state) {
        Object.keys(state).forEach(key => {
            Object.assign(state[key], initialState[key])
        })
    }
}

const store = new Vuex.Store({
    actions,
    modules,
    mutations,
    strict: debug,
    plugins: [
        createPersistedState({
          // NOTE(casio): tmp workaround to skip persisting of the notes modal status `showAccountNotesReader`
          //
          // `suggestion` holds nothing worth restoring: a cache of fetched articles, plus
          // in-flight request bookkeeping (`suggestionsDownloading`, `downloadingSuggestions`,
          // `isFetching`, `reloadQueue`) that describes requests which no longer exist by the
          // time the page loads again. Rehydrating the cache was also hiding quality-check
          // tags that arrive after the page does:
          //
          //   1. a selection becomes `processing_status: 'ready'` when synchronous processing
          //      finishes, which no longer covers checks that run off the request path -- those
          //      write their tag minutes later
          //   2. `isProcessing` (modules/suggestion.js) only matches 'added'/'pending', so both
          //      fetch paths read `ready` as final and skip that selection from then on
          //   3. with the cache persisted, a reload restored the same stale copy, leaving
          //      USER_DID_LOG_OUT -- which empties it -- as the only way to ever see the tag
          //
          // If you change `paths`: the plugin applies it when *writing* only. On load it merges
          // whatever is in storage, so a key removed here is still rehydrated once more before
          // the next save drops it for good.
          paths: [
            ...Object.keys(modules).filter(m => !['notes', 'suggestion'].includes(m)),
            'notes.allNotes',
          ]
        })
    ]
})

// import devState from './dev-store'
if (debug){
    // store.replaceState(devState)
}

import state from './testing-state';

if (testing){
    store.replaceState(state)
}

export default store
